module.exports = __webpack_public_path__ + "assets/asset_star.7aeb268c.svg";